module.exports = __webpack_public_path__ + "img/violet_001.876b5655.png";